export default __webpack_public_path__ + "images/6fcb83d25c376a8123da75539e2afa60.svg";